import React, { useState } from "react";
import "./CommunityAndFAQSection.css";
import { Helmet } from "react-helmet-async";

const faqs = [
  {
    question: "What Services Does Aikyam Sports Science Offer?",
    answer:
      "Aikyam Sports Science provides a comprehensive range of services including Strength & Conditioning, Injury Rehabilitation, Nutrition Services, Sports Psychology, Group Fitness Classes, and Sports Science Assessments, all designed to enhance athletic performance and well-being.",
  },
  {
    question: "How Can I Book a Session at Aikyam?",
    answer:
      "Booking a session is easy! Simply click on the 'Book a Session' button available on our website to schedule your appointment with one of our expert trainers or specialists.",
  },
  {
    question: "Do You Offer Personalized Training Programs?",
    answer:
      "Yes, we offer customized training programs tailored to individual needs, focusing on areas such as strength, agility, endurance, and recovery, ensuring optimal performance and progress.",
  },
  {
    question: "Are Your Services Suitable for All Fitness Levels?",
    answer:
      "Absolutely! Our programs are designed to cater to all fitness levels, from beginners to elite athletes, ensuring everyone receives appropriate guidance and support.",
  },
  {
    question: "How Can I Contact Aikyam Sports Science?",
    answer:
      "You can reach us via phone at +91 63632 02281 or +91 70193 86664, or email us at aikyamsports@gmail.com. Our center is located at the Center for Sports Science, Mahatma Gandhi Stadium, Ajjarakad, Brahmagiri, Udupi, Karnataka - 576101.",
  },
];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map((faq) => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer,
    },
  })),
};


const CommunityAndFAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  return (
    <>
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify(faqSchema)}
    </script>
  </Helmet>
    <section className="community-faq-section">
      {/* Community Part */}
      <div className="community-section">
        <h2 className="community-heading">
          Join Our <span className="highlight-text">Fitness Community</span>
        </h2>
        <p className="community-sub">
          Sign Up Now To Unlock Exclusive Access To Personalized Workout Plans,
          Expert Coaching, And A Supportive Community That Will Help You Achieve
          Your Fitness Goals.
        </p>

        <div className="community-cards">
          <div className="community-card">
            <h4>
              <span className="highlight-text">Personalized</span> Workout Plans
            </h4>
            <p>
              Customized routines that match your fitness level and goals,
              ensuring you achieve the best results in the most efficient way.
            </p>
          </div>
          <div className="community-card">
            <h4>
              Expert <span className="highlight-text">Coaching</span>
            </h4>
            <p>
              Work with certified trainers who will guide you every step of the
              way to ensure you're on the right track.
            </p>
          </div>
          <div className="community-card">
            <h4>
              Community <span className="highlight-text">Support</span>
            </h4>
            <p>
              Join a vibrant community of fitness enthusiasts where you can
              share experiences, get motivated, and stay inspired.
            </p>
          </div>
          <div className="community-card">
            <h4>
              Exclusive <span className="highlight-text">Resources</span>
            </h4>
            <p>
              Access premium content, including video tutorials, nutrition
              guides, and member-only discounts on fitness gear.
            </p>
          </div>
        </div>
      </div>

      {/* FAQ Part */}
      <div id="faq" className="faq-section" >
        <h2 className="faq-heading">FAQ</h2>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                {faq.question}
              </div>
              {activeIndex === index && (
                <div className="faq-answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
    </>
  );
};

export default CommunityAndFAQSection;
